import {
    Node,
    nodeInputRule,
    mergeAttributes, isString,
} from '@tiptap/core'
import {NodeView} from "@tiptap/pm/view";
import {ImgNodeView} from "./imageview";

export interface ImageOptions {
    inline: boolean,
    floats: string[],
    defaultFloat: string,
    HTMLAttributes: Record<string, any>,
}

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        image: {
            /**
             * Add an image
             */
            setImage: (options: { src: string, alt?: string, title?: string, float?: string, inline?: boolean }) => ReturnType,

            /**
             * Set image float
             */
            setImageFloat: (float: string) => ReturnType
        }
    }
}

export const inputRegex = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/

export const Image = Node.create<ImageOptions>({
    name: 'image',

    defaultOptions: {
        inline: true,
        floats: ['left', 'right', 'none', 'block-center', 'block-left', 'block-right'],
        defaultFloat: 'none',
        HTMLAttributes: {
            src: null,
            style: ''
        },
    },

    addNodeView(){
        return ({ editor, node, getPos, HTMLAttributes, decorations, extension }): NodeView => {
            let attrs = mergeAttributes(this.options.HTMLAttributes, HTMLAttributes);

            console.log(attrs);

            let nodeview = new ImgNodeView(editor, attrs, getPos)

            return {
                dom : nodeview.dom,
                contentDOM: nodeview.domContent,
                selectNode: () => {
                    nodeview.selectNode();
                },
                deselectNode: () => {
                    console.log("ZZZ DESELECT NODE: ", node);
                    nodeview.deselectNode();
                },

            }
        }
    },

    inline() {
        console.log("INLINE ", this.options.inline)
        return this.options.inline
    },

    group() {
        console.log("G ", this.options.inline)
        return this.options.inline ? 'inline' : 'block'
    },

    draggable: true,

    addAttributes() {
        return {
            width: {
                default: 'auto',
                parseHTML: element => ({
                    width: element.style.width || 'auto'
                }),
                renderHTML: attributes => {

                    let w = attributes.width;
                    if(!isString(w)){
                        w = w.width;
                    }

                    return {
                        'data-width': w,
                        style: 'width: ' + w
                    }
                }
            },
            float: {
                default: this.options.defaultFloat,
                parseHTML: element => ({
                    float: element.getAttribute('data-float') || this.options.defaultFloat,
                }),
                renderHTML: attributes => {

                    let style = [];
                    style.push('max-width: 100%;');

                    let f = attributes.float;

                    //hack bo czasami f to obiekt?
                    if(!isString(f)){
                        f = f.float;
                    }

                    if (f !== this.options.defaultFloat) {
                        if (f.startsWith("block-")) {

                            if (f == 'block-left') {
                                style.push('display: block; margin-right: auto;');
                            }

                            if (f == 'block-right') {
                                style.push('display: block; margin-left: auto;')
                            }

                            if (f == 'block-center') {
                                style.push('display: block; margin-left: auto; margin-right: auto;')
                            }

                        } else {
                            style.push(`float: ${f}`);
                        }
                    }


                    return {
                        'data-float': f,
                        style: style.join(';')
                    }
                },
            },
            src: {
                default: null,
            },
            alt: {
                default: null,
            },
            title: {
                default: null,
            },
        }
    },

    parseHTML() {
        return [
            {
                tag: 'img[src]',
            },
        ]
    },

    renderHTML({HTMLAttributes}) {
        return ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]
    },

    addCommands() {
        return {
            setImage: options => ({commands}) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: options,
                });
            },

            setImageFloat: (float: string) => ({commands}) => {
                if (!this.options.floats.includes(float)) {
                    return false;
                }

                return commands.updateAttributes('image', {
                    float: float,
                    alt: ''
                });

            }
        }
    },

    addInputRules() {
        return [
            nodeInputRule({
                find: inputRegex,
                type: this.type,
                getAttributes: match => {
                    const [, , alt, src, title] = match
                    return {src, alt, title}
                },
            }),
        ]
    },
})